import ReactDOM from 'react-dom';

const globalMessageContainer = document.getElementById('global-message-container');

const MessagePortal = ({ children }) => ReactDOM.createPortal(children, globalMessageContainer);

export default MessagePortal;
